// Main Cashier Getters

export const getCashiersList = state => {
  return state.cashiersList
}

export const getCashierInfo = state => {
  return state.cashierInfo
}
